<template>
  <div>
    <div style="width:100%;margin:5px auto;display: flow-root;margin-bottom: 60px;">
      <div style="position: sticky;top: 0;z-index: 999;">
        <van-tabs v-model="active"
          color="#ffc002"
          @click="onClick"
          :sticky="true">
          <van-tab title="全部"></van-tab>
          <van-tab title="待下单"></van-tab>
          <van-tab title="待接单"></van-tab>
          <van-tab title="已接单"></van-tab>
          <van-tab title="待评价"></van-tab>
          <van-tab title="已评价"></van-tab>
          <van-tab title="已撤单"></van-tab>
        </van-tabs>
      </div>

      <!-- <van-sidebar v-model="activeKey"
            color="#ffc002"
            style="
            width: 25%;
            float: left;
            position: fixed;
            overflow-y: scroll;
            height: 87%;
          ">
            <van-sidebar-item :title="item.Name"
              v-for="item in ServiceType"
              :key="item.id"
              @click="orderType(item.id)">
            </van-sidebar-item>
          </van-sidebar> -->
      <div style="
            margin: 0px auto;
            display: flow-root;
            width: 95%;
          ">
        <div v-for="item in ServiceList"
          :key="item.SId">
          <div class="van-card"
            @click="getOrder('/ylOrder/orderList/orderMy/' + item.OrderId)">
            <div class="van-card__header"><a class="van-card__thumb">
                <div class="van-image"
                  style="width: 100%; height: 100%;"
                  v-if="item.SerImgUrl != ''">
                  <img :src="item.SerImgUrl"
                    onerror="onerror=null;src='https://lycaljdapi.dexian.ren//upload/images/2021/12/3559e43a-6b7.png'"
                    class="van-image__img"
                    style="object-fit: cover;border-radius: 8px;">
                </div>
                <div class="van-image"
                  style="width: 100%; height: 100%;"
                  v-else>
                  <img src="https://lycaljdapi.dexian.ren//upload/images/2021/12/3559e43a-6b7.png"
                    class="van-image__img"
                    style="object-fit: cover;border-radius: 8px;">
                </div>
              </a>
              <div class="van-card__content">
                <div>
                  <div class="status van-multi-ellipsis--l2">{{item.StatusDesc}}</div>
                  <div class="van-card__desc van-ellipsis"
                    style="font-weight: 600;color: black;font-size:16px;margin-top:15px;">服务数量：{{item.SerNum}}</div>
                </div>
                <div class="van-card__bottom">
                  <div class="van-card__price">
                    <div>
                      <span class="van-card__price-integer"
                        style="color: #ff7e1e;margin-bottom:20px;"
                        v-if="item.Amount == '0'">免费</span>
                      <span class="van-card__price-integer"
                        v-else
                        style="color: red;margin-bottom:20px;">{{item.Amount}}元</span>

                    </div>
                    <div v-if="item.Status == '5'"><span class="van-card__price-integer"
                        style="color: red;margin-bottom:20px;">
                        <van-rate v-model="item.Satisfaction"
                          :size="25"
                          color="#ffd21e"
                          void-icon="star"
                          void-color="#eee"
                          readonly>
                        </van-rate>
                      </span>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div v-if="item.Status == '5'"
            style="background-color: #fafafa;"
            @click="getOrder('/ylOrder/orderList/orderMy/' + item.OrderId)">
            <div style="margin-left:10px;margin-bottom:10px;">{{item.EvalContent}}</div>
            <div v-if="item.EvalImgs != null && item.EvalImgs != ''">
              <span v-for="(imgurl,index) in item.EvalImgs.split(',')"
                :key="index">
                <img :src="url+imgurl"
                  style="width:75px;height:75px;margin:10px;border-radius: 8px;" />
              </span>
            </div>

          </div>
          <div style="width:100%;text-align: right;marign-right:10px;border-bottom: 1px solid #c6c6c6;background-color: #fafafa;">
            <van-button size="small"
              plain
              round
              v-if="item.Status == '4'"
              color="#ffc002"
              type="primary"
              style="margin: 5px;padding: 0 15px"
              @click="appraise(item)">
              评价
            </van-button>
            <van-button size="small"
              v-if="item.Status == '1'"
              color="#ffc002"
              plain
              round
              type="primary"
              style="margin: 5px;padding: 0 15px"
              @click="orderRen(item.OrderId)">
              下单
            </van-button>

            <van-button size="small"
              v-if="item.Status == '2' &&  jiedanShow"
              color="rgb(2 99 255)"
              plain
              round
              type="primary"
              style="margin: 5px;padding: 0 15px"
              @click="orderOn(item.OrderId)">
              接单
            </van-button>
            <van-button size="small"
              v-if="item.Status == '3' &&  jiedanShow"
              color="#009688"
              plain
              round
              type="primary"
              style="margin: 5px;padding: 0 15px"
              @click="arrive(item.OrderId)">
              送达
            </van-button>
            <van-button size="small"
              v-if="item.Status == '1' || item.Status == '2'  || item.Status == '3'"
              color="#ffc002"
              plain
              round
              type="primary"
              style="margin: 5px;padding: 0 15px"
              @click="getRevokeOrder(item)">
              撤单
            </van-button>

            <van-button size="small"
              v-if="item.Status == '1'"
              plain
              round
              type="warning"
              style="margin: 5px;padding: 0 15px"
              @click="delet(item)">
              删除
            </van-button>
          </div>
          <!-- <div style="float: left;margin:5px 0;border-bottom:1px solid #C6C6C6;">
            <div class="van-ellipsis title">{{item.StaName}}</div>
            <div class="status">{{item.StatusDesc}}</div>
            <div v-if="item.SerImg != '' && item.SerImg != null"
              style="float:left;width:25%;">
              <img :src="item.SerImgUrl"
                style="width:100%;border-radius: 5px;" />
            </div>
            <div v-else
              style="float:left;width:25%;">
              <img src="http://lycaljdapi.dexian.ren//upload/images/2021/12/aa7c3ea2-bfd.png"
                style="width:100%;border-radius: 5px;" />
            </div>
            <div style="float:left;margin-left:5px;font-size: 14px;color: #646566;    width: 60%;">
              <span style="line-height:30px;">服务数量：{{item.SerNum}}<br />
                <span v-if="item.Amount != '0'">合计金额：{{item.Amount}}元<br /></span>
                <span v-if="item.Amount == '0'">
                  <van-tag plain
                    type="primary"
                    color="#ffc002">免费</van-tag><br />
                </span>
              </span>
            </div>

          <div v-if="item.Status == '5'">
            <div style="margin:5px 0;">
              <van-rate v-model="item.Satisfaction"
                :size="25"
                color="#ffd21e"
                void-icon="star"
                void-color="#eee"
                readonly>
              </van-rate>
            </div>
            <div>{{item.EvalContent}}</div>
            <img :src='SerImg'
              style="width:75px;height:75px;margin:10px;border-radius: 5px;" />
          </div>
        </div> -->

        </div>
      </div>
      <van-dialog v-model="arriveShow"
        title="提示"
        show-cancel-button
        :beforeClose="beforeClose">
        <van-field v-model="dataForm.RevReason"
          label="撤单原因"
          placeholder="请输入撤单原因" />
      </van-dialog>
      <van-action-sheet v-model="orderRenshow"
        title="配送老人"
        @close='close()'>
        <div class="content">
          <van-radio-group v-model="oldManList"
            v-for="item in MyBindInfoList"
            :key="item.BindId"
            style="margin: 10px;padding:15px 10px;background: #f6f7f8;border-radius: 5px;">
            <van-radio :name="item.BindId"
              checked-color="#ffc002"
              style="padding: 20rpx;">
              <div style="font-size: 18px;font-weight: 600;margin-bottom: 10rpx;margin: 5px;">
                {{item.OMName}}
                <span style="font-weight: 500;">{{item.OMMobile}}</span>
                <span style="padding-left: 20px;"
                  @click="updata(item)">
                  <van-icon name="edit" /></span>
                <span style="padding-left: 20px;"
                  @click="addOldMan()">
                  <van-icon name="add-o" /></span>
              </div>
              <!-- <div style="font-size: 14px;margin-bottom: 10rpx;">{{item.Summary}}</div> -->
              <div style="margin: 5px;">{{item.OMAddr}}</div>
            </van-radio>
          </van-radio-group>
          <div style="">
            <div style="width: 95%; bottom: 0; position: fixed; padding: 10px">
              <van-button round
                type="primary"
                size="normal"
                style="font-size: 16px; width: 100%;float:none;"
                color="black"
                @click="addOrder()">
                确定
              </van-button>
            </div>
          </div>
        </div>
      </van-action-sheet>

      <van-action-sheet v-model="orderRenAddshow"
        title="配送老人信息"
        @close='close()'>
        <div class="content">
          <van-field v-model="oldmanForm.OMIdCard"
            class="shuru"
            name="oldmanForm.OMIdCard"
            label="身份证号"
            placeholder="请输入身份证号" />
          <van-field v-model="oldmanForm.OMMobile"
            class="shuru"
            name="oldmanForm.OMMobile"
            label="联系电话"
            placeholder="请输入老人联系电话" />
          <van-field v-model="oldmanForm.OMAddr"
            type="textarea"
            rows="1"
            autosize
            class="shuru"
            name="oldmanForm.OMAddr"
            label="居住地址"
            placeholder="请输入老人现居住地址" />
          <div style="width: 95%; bottom: 0; position: fixed; padding: 10px">
            <van-button round
              block
              type="info"
              color="black"
              @click="submit()">保存</van-button>
          </div>
        </div>
      </van-action-sheet>
      <van-empty v-if="orderListShow" />
    </div>
    <!-- 服务站选择器 -->
    <van-popup v-model="marriageShow"
      position="bottom"
      get-container="body">
      <van-picker show-toolbar
        :columns="marriageData"
        value-key="Title"
        @cancel="marriageShow = false"
        @confirm="Qrorder">
      </van-picker>
    </van-popup>
    <van-dialog v-model="arriveShowSd"
      title="配送信息"
      show-cancel-button
      :beforeClose="beforeCloseSd">
      <van-field v-model="dataFormSd.EntName"
        label="服务商"
        placeholder="请输入服务商" />
      <van-field v-model="dataFormSd.EntStaff"
        label="服务人员"
        placeholder="请输入服务人员" />
    </van-dialog>
  </div>
</template>

<script>
import {
  WeGetServiceList,
  WeGetMyOrderPage,
  WeRevokeOrder,
  WeDeleteOrder,
  WePlaceOrder,
  WeGetMyBindInfoPage,
  WeSaveBindInfo
} from "@/api/ylOrder.js";
import {
  WeGetStaOrderPage,
  WeDeliveryOrder,
  WeRecviceOrder,
  WeSaveSPServiceRec,
  GetYLOrganList,
} from "@/api/Lycal.js";
import {
  setOpenId,
  getOpenId,
  removeOrderId,
  getStaLevel,
  setStaLevel,
  setOCode,
  getOCode,
  getToken,
  setToken,
  removeToken,
  removeStaLevel,
  removeOCode
} from "@/utils/auth";
import Vue from 'vue';
import { Toast } from 'vant';
import { Dialog } from "vant";
Vue.use(Dialog);
Vue.use(Toast);
export default {
  data () {
    return {
      ServiceList: [],
      active: 0,
      activeKey: 0,
      show: false,
      orderListShow: false,
      arriveShow: false,
      arriveShowSd: false,
      status: '0',
      ServiceType: [
        { Name: '助餐', id: '1' },
        { Name: '助洁', id: '2' },
        { Name: '助行', id: '3' },
        { Name: '助浴', id: '4' },
        { Name: '助医', id: '5' },
        { Name: '康复', id: '6' },
        { Name: '巡访关爱', id: '7' },
        { Name: '其他', id: '99' },
      ],
      SerImg: [],
      EvalImgs: [],
      url: 'http://lycaljdapi.dexian.ren/',
      dataForm: {
        RevReason: '',
      },
      dataFormSd: {
        OrderId: "",
        EntName: "",
        EntStaff: "",
      },
      oid: '',
      oldManList: "",
      MyBindInfoList: [],
      orderRenshow: false,
      orderRenAddshow: false,
      oldmanForm: {
        OMIdCard: '',
        OMMobile: '',
        OMAddr: '',
        BindId: undefined
      },
      orId: '',
      postOrderId: "",
      acctoken: "",
      orderIdXd: "",
      oCode: "", //服务站编号
      staLevel: "", //服务站等级
      marriageData: [], //服务站列表
      marriageShow: false, //服务站弹框
      jiedanShow: false,
    }
  },
  created () {
    // 获取并保存openid
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }
    if (this.$route.query["oCode"]) {
      removeOCode();
      setOCode(this.$route.query["oCode"]);
    }
    // 获取并保存accToken
    if (this.$route.query["accToken"]) {
      removeToken();
      setToken(this.$route.query["accToken"]);
    }
    this.acctoken = getToken();
    this.postOrderId = getOCode();
    this.getYLOrganList();
    if (this.$route.query["staLevel"]) {
      removeStaLevel();
      setStaLevel(this.$route.query["staLevel"]);
      if (getStaLevel() == '18137739660') {
        this.jiedanShow = true
      } else {
        this.jiedanShow = false
      }
    }
    console.log(getStaLevel());
    this.getServiceList();
  },
  methods: {
    // 接单弹框
    orderOn (val) {
      this.marriageShow = true;
      this.orderIdXd = val;
    },
    // 获取服务站列表
    getYLOrganList () {
      var oCode = this.postOrderId;
      var Token = this.acctoken;
      console.log(oCode);
      GetYLOrganList({ accToken: Token, orgCode: oCode, ssLevel: 2 }).then(
        (res) => {
          this.marriageData = res.data.data;
        }
      );
    },
    // 接单
    Qrorder (val) {
      var staId = val.SSId;
      var orderId = this.orderIdXd;
      Dialog.confirm({
        title: "提示",
        message: "是否确认指定派单!",
      }).then(() => {
        WeRecviceOrder({
          accToken: this.acctoken,
          OrderId: orderId,
          StaId: staId,
        }).then((res) => {
          if (res.data.code == 0) {
            Toast.success("派单成功!");
            this.getServiceList();
            this.marriageShow = false;
          } else {
            Toast.fail(res.data.msg);
          }
        });
      });
    },
    // 送达
    arrive (val) {
      this.arriveShowSd = true;
      this.orderIdXd = val;
    },
    beforeCloseSd (action, done) {
      if (action === "confirm") {
        setTimeout(done, 1000);
        if (!this.dataFormSd.EntName || !this.dataFormSd.EntStaff) {
          this.$toast("请输入服务商和服务人员");
          done(false); //不关闭弹框
        } else {
          WeDeliveryOrder({
            accToken: this.acctoken,
            OrderId: this.orderIdXd,
            EntName: this.dataFormSd.EntName,
            EntStaff: this.dataFormSd.EntStaff,
          }).then((res) => {
            if (res.data.code == 0) {
              Toast.success("送达成功!");
              this.dataFormSd.EntName = "";
              this.dataFormSd.EntStaff = "";
              this.orderIdXd = "";
              this.getServiceList();
            } else {
              Toast.fail(res.data.msg);
            }
          });
        }
      } else if (action === "cancel") {
        done(); //关闭
      }
    },
    onClick: function (name, title) {
      console.log(name);
      this.status = name
      if (this.status == '6') {
        this.status = '9'
        this.getServiceList();
      } else {
        this.getServiceList();
      }
      // else if (this.oType == '2') {
      //   this.oSerKind = undefined
      //   this.getServiceList();
      // }

    },

    getOrder: function (row) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + row,
        });
      } else {
        this.$router.push(row);
      }
      // this.$router.push("/ylOrder/currentOrder/" + row + "/" + this.oCode);
    },
    // 服务项目类型
    orderType: function (row) {
      console.log(row);
      this.oSerKind = row
      this.getServiceList();
    },
    getServiceList: function () {
      WeGetMyOrderPage({ openID: getOpenId(), page: '1', limit: '999', status: this.status }).then((res) => {
        if (res.data.code == '0') {
          if (res.data.data.length != '0') {
            this.ServiceList = res.data.data;
            this.orderListShow = false
          } else {
            // Toast.success('暂未下单');
            this.ServiceList = []
            this.orderListShow = true
          }
        } else {

        }
      });
    },
    // 撤单
    getRevokeOrder: function (row) {
      this.arriveShow = true;
      console.log(row.OrderId);
      this.oid = row.OrderId
    },
    beforeClose (action, done) {
      if (action === "confirm") {
        setTimeout(done, 1000);
        WeRevokeOrder({ OpenID: getOpenId(), OrderId: this.oid, RevReason: this.dataForm.RevReason }).then((res) => {
          if (res.data.code == 0) {
            Toast.success('撤单成功');
            this.oid = ''
            this.getServiceList();
          }
        });

      } else if (action === "cancel") {
        done(); //关闭
      }
    },
    // 删除订单
    delet: function (row) {
      console.log(row.OrderId);
      WeDeleteOrder({ OpenID: getOpenId(), OrderId: row.OrderId }).then((res) => {
        if (res.data.code == 0) {
          Toast.success('删除成功');
          this.getServiceList();
          removeOrderId()
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    //下单
    addOrder: function () {
      // Dialog.confirm({
      //   title: "提示",
      //   message: "确定要下单吗!",
      // })
      //   .then(() => {
      WePlaceOrder({ OpenID: getOpenId(), OrderId: this.orId, BindId: this.oldManList }).then(
        (res) => {
          if (res.data.code == '0') {
            Toast.success('下单成功');
            this.getServiceList();
            this.showPopupShow = false;
            this.orderRenshow = false
          } else {
            Toast.fail(res.data.msg);
          }
        }
      );
      // })
    },
    appraise: function (row) {
      this.$router.push("/ylOrder/orderList/appraise/" + row.OrderId);
    },
    close: function () {
      // console.log(123123);
      this.oldManList = ''
      this.oldmanForm.OMIdCard = ''
      this.oldmanForm.OMMobile = ''
      this.oldmanForm.OMAddr = ''
    },
    add: function (row) {
      console.log(row);
    },
    // 下单人
    orderRen: function (row) {
      console.log(row);
      this.orId = row
      this.orderRenshow = true
      this.getMyBindInfoPage()
    },
    getMyBindInfoPage: function () {
      WeGetMyBindInfoPage({ openID: getOpenId(), page: '1', limit: '999' }).then((res) => {
        if (res.data.code == '0') {
          if (res.data.data.length != '0') {
            this.MyBindInfoList = res.data.data;
            // this.orderListShow = false
          } else {
            // Toast.fail('未绑定老人信息');
            this.MyBindInfoList = []
            this.orderRenshow = false
            this.orderRenAddshow = true
            // this.orderListShow = true
          }
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    // 添加老人信息
    submit () {
      console.log(this.oldmanForm);
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!reg.test(this.oldmanForm.OMIdCard)) {
        Toast.fail("身份证号码不正确");
      } else if (this.oldmanForm.OMMobile == '') {
        Toast.fail("请输入老人联系电话");
      } else if (this.oldmanForm.OMAddr == '') {
        Toast.fail("请输入老人现居住地址");
      } else {
        WeSaveBindInfo(
          {
            OpenID: getOpenId(),
            OMIdCard: this.oldmanForm.OMIdCard,
            OMMobile: this.oldmanForm.OMMobile,
            OMAddr: this.oldmanForm.OMAddr,
            BindId: this.oldmanForm.BindId,
          }
        ).then((res) => {
          if (res.data.code == '0') {
            Toast.success('绑定成功');
            this.orderRenAddshow = false
            this.orderRenshow = true
            this.oldmanForm.OMIdCard = ''
            this.oldmanForm.OMMobile = ''
            this.oldmanForm.OMAddr = ''
            this.oldmanForm.BindId = undefined
            this.getMyBindInfoPage()
          } else {
            Toast.fail(res.data.msg);
          }

        });
      }
    },
    addOldMan: function () {
      this.orderRenAddshow = true
    },
    // 编辑老人信息
    updata: function (row) {
      this.orderRenAddshow = true
      console.log(row);
      this.oldmanForm = Object.assign({}, row);
    },
  }
}
</script>

<style scoped>
/* .van-button__content {
  float: left !important;
} */
.van-button__text {
  display: inline-grid !important;
}
.van-action-sheet {
  height: 500px !important;
}
.van-action-sheet__content {
  margin-bottom: 70px !important;
}
.van-sidebar-item--select::before {
  background-color: #ffc002 !important;
}
.title {
  margin: 10px 0;
  font-size: 17px;
  font-weight: 600;
  width: 70%;
  float: left;
}
.status {
  margin: 11px 0;
  font-size: 17px;
  width: 25%;
  float: right;
  text-align: center;
  color: #646566;
}
</style>